import React from 'react';
import ErrorPage from './error';
import Recommend from '@views/modules/recommend';

import MainLayout from '@views/layouts/main-layout';
import { Block } from '@views/components/block';
import { NextSeo } from 'next-seo';
import matter from 'gray-matter';
import ReactMarkdown from 'react-markdown';
import _get from 'lodash/get';
import LazyImage from '@views/components/lazy-image';

const styleTitle = {
  fontSize: '2.5rem',
  textAlign: 'center',
  fontWeight: 'bold',
  maxWidth: '700px',
  wordWrap: 'break-word',
};

export default function PostTemplate({ fallback, content, data }) {
  // This holds the data between `---` from the .md file
  // console.log(data);
  if (fallback) {
    return <ErrorPage statusCode={404} />;
  }

  return (
    <MainLayout>
      <NextSeo title={_get(data, 'title')} />
      <Block isSection className="mb-4">
        <div>
          <LazyImage
            src={_get(data, 'coverImage')}
            className="post-image"
            alt={_get(data, 'coverImage')}
          />
        </div>
        <Block.Header style={{ justifyContent: 'center' }}>
          <Block.Title as="h1" style={styleTitle}>
            {_get(data, 'title')}
          </Block.Title>
        </Block.Header>
        <Block.Body className="mt-4">
          <Block.Html>
            <h5>{_get(data, 'excerpt')}</h5>

            <ReactMarkdown source={content} />
          </Block.Html>
        </Block.Body>
      </Block>

      <Recommend />
    </MainLayout>
  );
}

PostTemplate.getInitialProps = async (context: any) => {
  try {
    const { slug } = context.query;
    // Import our .md file using the `slug` from the URL
    const content = await import(`../../content/${slug}.md`);

    // Parse .md data through `matter`
    const data = matter(content.default);

    // Pass data to the component props
    return { ...data, fallback: false };
  } catch (ex) {
    return {
      fallback: true,
    };
  }
};
